import type { Localized, CollectionItem, FieldDef } from './types';

export type Locale = 'es' | 'en';

// Lee un valor localizado al locale activo con fallback es→en→en→es.
export function pickLoc(v: Localized | undefined, locale: Locale): string {
  if (!v) return '';
  return v[locale] ?? v.es ?? v.en ?? '';
}

// Etiqueta de un campo en el locale del panel (es por defecto).
export function fieldLabel(f: FieldDef, locale: Locale = 'es'): string {
  return pickLoc(f.label, locale) || f.key;
}

export function fieldHelp(f: FieldDef, locale: Locale = 'es'): string {
  return pickLoc(f.help, locale);
}

export function fieldExample(f: FieldDef, locale: Locale = 'es'): string {
  return pickLoc(f.example, locale);
}

// Título mostrable de un ítem (reservado `title` nested-bilingüe).
export function itemTitle(item: CollectionItem, locale: Locale = 'es'): string {
  const t = item.data?.title as Localized | undefined;
  return pickLoc(t, locale) || item.slug || '(sin título)';
}

export function slugify(text: string): string {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-|-$/g, '');
}
